function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Lesson-aditional-icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_546",
  transform: "translate(12.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path_779",
  fill: "#9CA9D6",
  fillRule: "nonzero",
  points: "8.924 16.584 27.417 5.193 35.697 11.93 16.911 23.355"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.017,38.394 C0.884655264,37.1912793 0.413857111,35.5098573 0.757,33.894 C12.257,40.062 23.993,46.346 35.492,52.515 C35.4281853,53.8152788 35.9086294,55.0834194 36.818,56.015 L55.654,37.444 L56.617,37.96 L37.089,57.213 L2.017,38.396 L2.017,38.394 Z M1.194,33.136 L35.865,51.718 L50.9,36.894 L32.394,47.58 L31.61,48.032 L30.947,47.417 L8.137,26.29 L1.194,33.136 Z",
  id: "Path_780",
  fill: "#EEDC98"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.107,14.175 L26.325,0.77 L55.725,27.182 L31.977,40.893 C22.3523333,31.987 12.7286667,23.081 3.106,14.175 L3.107,14.175 Z M11.023,16.813 C12.871,18.5103333 14.719,20.208 16.567,21.906 L33.95,11.87 L28.405,6.777 L11.023,16.813 L11.023,16.813 Z M2.579,19.47 L31.779,46.517 L55.527,32.805 L54.727,32.064 L31.817,45.291 C31.1725989,44.1604358 31.0276829,42.8127167 31.417,41.571 C21.845,32.705 12.068,23.665 2.495,14.799 C1.75556098,16.2760638 1.78732221,18.0218107 2.58,19.471 L2.579,19.47 Z",
  id: "Path_781",
  fill: "#FFFFFF"
})));
function SvgLessonAditionalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "69px",
    viewBox: "0 0 80 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lesson-aditional-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonAditionalIcon);
export default __webpack_public_path__ + "static/media/Lesson-aditional-icon.0d11fffe16885cf839e0ce3ec4b02369.svg";
export { ForwardRef as ReactComponent };